module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/TV1-9318e80ded5617aba88663e6f784f603.svg";